import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const CheckBoxCheckIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.438 1.04695L10.4248 1.06186L10.4129 1.07776L4.18021 9.38631C4.10218 9.46972 4.03081 9.49534 3.9957 9.49932C3.97919 9.50119 3.96909 9.49897 3.96172 9.49611C3.95458 9.49334 3.93704 9.48497 3.91246 9.45712L3.90274 9.44611L3.89239 9.43568L0.59797 6.11754C0.482146 5.97774 0.469852 5.7559 0.556013 5.59751C0.608614 5.54818 0.659288 5.53272 0.699846 5.53042C0.746761 5.52777 0.800234 5.54184 0.849556 5.57905L3.5496 8.30773L3.95521 8.71765L4.30351 8.25805L10.0961 0.614436C10.1744 0.530423 10.246 0.504673 10.2813 0.500684C10.2978 0.498814 10.3079 0.501031 10.3152 0.503891C10.3224 0.506657 10.3399 0.515032 10.3645 0.542888L10.7374 0.213745L10.3645 0.542888C10.4456 0.634746 10.4901 0.743929 10.4985 0.838878C10.5064 0.928576 10.4829 0.996032 10.438 1.04695Z"
        {...svgAttrs}
      />
    </svg>
  );
};

export default CheckBoxCheckIcon;
